import React, { useEffect, useState } from "react";
import "./entity.css";
import {Grid, Button} from "@mui/material";
import EntityTable from "./EntityTable";
import Swal from "sweetalert2";
import instance from "../../ApiInstance/Inetrceptor";
import AddIcon from "@mui/icons-material/Add";
import EntityDrawer from "./Addmaintain";
import EditEntityDrawer from "./Editmaintain";
import CustomTheme from "../../Customtheme/Themes"

const MaintainEntity = () => {
  const { drawerWidth, isXs, isSm, isMd, isLg, isXl } = CustomTheme();
  const [loader, setLoader] = useState(true);
  const [backDrop, setBackDrop] = useState(false);
  const [showmoreLoader, setShowmoreLoader] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [pageNo, setPageNo] = useState(1);
  const [totalRecods, setTotalRecods] = useState(0);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [isDrawerOpenedit, setIsDrawerOpenedit] = useState(false);
  const [getmaintaindata, setGetmaintaindata] = useState([]);
  const [entitytypedata, setEntitytypedata] = useState([]);
  const [endpointtypedata, setEndpointtypedata] = useState([]);
  const [addentity, setAddentity] = useState({
    entity_id: 0,
    entity_name: "",
    entity_sender_code: "",
    entity_org_code: "",
    entity_receiver_code:"",
    entity_type_id: 0,
    entity_type_name: null,
    recipient_endpoint_address: "",
    recipient_endpoint_username: "",
    recipient_endpoint_password: "",
    recipient_endpoint_folder: "",
    recipient_endpoint_port: "",
    recipient_endpoint_type_id: 0,
    endpoint_type_name: null,
    recipient_endpoint_folder: "",
    recipient_endpoint_port: "",
  });
  const [createentitydata, setCreateentitydata] = useState({});
  const [sortField, setSortField] = useState("entity_name");
  const [sortOrder, setSortOrder] = useState("asc");
  const [maindata, setMaindata] = useState({});
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedRowIndex, setSelectedRowIndex] = useState(null);
  const [searchText, setSearchText] = useState("");
  const open = Boolean(anchorEl);

  const handleClickEditDelete = (event, maintain, index) => {
    if (event.target.innerText === "Edit") {
      setMaindata(maintain);
      setIsDrawerOpenedit(true);
      setAnchorEl(null);
      setSelectedRowIndex(null);
    } else if (event.target.innerText === "Delete") {
      Swal.fire({
        icon: "question",
        text: "Are you sure you want to delete",
         
        customClass: {
          confirmButton: "custom-confirm-button-class",
          cancelButton: "custom-cancle-button-class",
          centerButton: "custom-center-button-class",
        },
        buttonsStyling: false,
        showCancelButton: true,
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        allowOutsideClick: false,
        reverseButtons: true, 
      }).then((responce) => {
        if (responce?.isConfirmed) {
          deleteMaintainData(maintain?.entity_id);
        } else {
        }
      });
    }
    setAnchorEl(null);
    setSelectedRowIndex(null);
  };
  const handleEditClick = (event, index) => {
    setAnchorEl(event.currentTarget);
    setSelectedRowIndex(index);
  };
  const handleSort = (field) => {
    const order = field === sortField && sortOrder === "asc" ? "desc" : "asc";
    console.log("field", order);
    setSortField(field);
    setSortOrder(order);
    GetMaintainData(pageNo, field, order);
  };
  const GetMaintainData = (
    pageNumber = pageNo,
    field = sortField,
    order = sortOrder,
    searchText
  ) => {
    const body = {
      id: "",
      searchtext: searchText ?? "",
      pageno: pageNumber,
      pagesize: 10,
      sortby: field ?? "",
      sortord: order ?? "",
    };
    instance
      .post("api/v1/Master/Entity/Get", body)
      .then((res) => {
        const newData = res?.data?.Value ?? [];
        setTotalRecods(res?.data?.Records);
        if (pageNumber === 1) {
          setGetmaintaindata(res?.data?.Value ?? []);
        } else {
          setGetmaintaindata((prevData) => [...prevData, ...newData]);
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setLoader(false);
        setShowmoreLoader(false);
      });
  };
  const deleteMaintainData = (entityId) => {
    instance
      .delete(`api/v1/Master/Entity/Delete/${entityId}`)
      .then((res) => {
        const ResultData = res?.data?.ResultMessage ?? [];
        if (ResultData === "Deletion Success") {
          setGetmaintaindata((prevData) => {
            return prevData.filter(row => row.entity_id !== entityId);
          });
           GetMaintainData();
          Swal.fire({
            icon: "success",
            title: "Deleted!",
            text: ResultData,
            customClass: {
              confirmButton: "custom-confirm-button-class",
            },
            buttonsStyling: false,
            showCancelButton: false,
            confirmButtonText: "OK",
            allowOutsideClick: false,
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: ResultData,
            customClass: {
              confirmButton: "custom-cancle-button-class",
            },
            buttonsStyling: false,
            showCancelButton: false,
            confirmButtonText: "OK",
          });
        }
      })
      .catch((err) => {
        console.log("newData12", err);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          customClass: {
            confirmButton: "custom-cancle-button-class",
          },
          buttonsStyling: false,
          showCancelButton: false,
          confirmButtonText: "OK",
        });
      })
      .finally(() => {
        setLoader(false);
        setShowmoreLoader(false);
      });
  };
  const GetEntityTypeData = () => {
    const body = {
      id: "",
      searchtext: "",
    };
    instance
      .post("api/v1/Master/EntityType/Get", body)
      .then((res) => {
        setEntitytypedata(res?.data?.Value ?? []);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
      });
  };
  const GetEndpointData = () => {
    const body = {
      id: "",
      searchtext: "",
    };
    instance
      .post("api/v1/Master/EndpointType/Get", body)
      .then((res) => {
        setEndpointtypedata(res?.data?.Value ?? []);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
      });
  };
  const handleInputChange = (event) => {
    const { id, value } = event.target;
    const sanitizedValue =
    id === "recipient_endpoint_port" ? value.replace(/[^0-9]/g, "") : value;
    setAddentity((prevData) => ({
      ...prevData,
      [id]: sanitizedValue,
    }));
  };
  const handleButtonClick = () => {
    setIsDrawerOpen(true);
  };
  const handleCloseErrorcode = () => {
    setError("");
  };
  const handleDrawerClose = (event) => {
      setIsDrawerOpen(false);
      setError("");
      setSuccess("");
  };
  const handleDrawerCloseedit = (event) => {
      setIsDrawerOpenedit(false);
      setError("");
      setSuccess("");
  };
  const handle_createEntity = (event) => {
    event.stopPropagation();
    setIsDrawerOpen(true);
    const entityname = addentity.entity_name
      ? addentity.entity_name.trim()
      : "";
    const entityType = addentity?.entity_type_name
      ? addentity.entity_type_name.trim()
      : "";
    const EndpointType = addentity?.endpoint_type_name
      ? addentity.endpoint_type_name.trim()
      : "";
    const entityadd = addentity.recipient_endpoint_address
      ? addentity.recipient_endpoint_address.trim()
      : "";
    const entityUser = addentity.recipient_endpoint_username
      ? addentity.recipient_endpoint_username.trim()
      : "";
    const entitypass = addentity.recipient_endpoint_password
      ? addentity.recipient_endpoint_password.trim()
      : "";

    if (!entityname ||!entityadd ||!entityUser ||!entitypass ||!entityType ||!EndpointType
    ) {
      setError("Please enter all the fields mandatory.");
      setTimeout(() => {
        handleCloseErrorcode();
      }, 5000);
    } else {
      setBackDrop(true);
      const body = {
        entity_id: 0,
        entity_name: addentity.entity_name,
        entity_sender_code: addentity.entity_sender_code,
        entity_org_code: addentity.entity_org_code,
        entity_receiver_code:addentity.entity_receiver_code,
        entity_type_id: addentity.entity_type_id,
        recipient_endpoint_address: addentity.recipient_endpoint_address,
        recipient_endpoint_username: addentity.recipient_endpoint_username,
        recipient_endpoint_password: addentity.recipient_endpoint_password,
        recipient_endpoint_folder: addentity.recipient_endpoint_folder,
        recipient_endpoint_port: addentity.recipient_endpoint_port,
        recipient_endpoint_type_id: addentity.recipient_endpoint_type_id,
      };
      instance
        .post("api/v1/Master/Entity/Post", body)
        .then((res) => {
          console.log("resp", res);
          setCreateentitydata(res?.data?.Value ?? []);
          if (res?.data?.Success) {
            setError("");
            setSuccess(res?.data?.ResultMessage);
            GetMaintainData(1);
            setTimeout(() => {
              setSuccess(null);
            }, 5000);
          } else {
            setError(res?.data?.ResultMessage);
            setTimeout(() => {
              setError(null);
            }, 5000);
          }
          setAddentity({
            entity_name: "",
            entity_sender_code: "",
            entity_org_code: "",
            entity_receiver_code: "",
            entity_type_id: 0,
            recipient_endpoint_address: "",
            recipient_endpoint_username: "",
            recipient_endpoint_password: "",
            recipient_endpoint_folder: "",
            recipient_endpoint_port: "",
            recipient_endpoint_type_id: 0,
          });
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          setBackDrop(false);
        });
    }
  };
  const handle_EditEntity = (information, setInformation) => {
    setBackDrop(false);
    const entityname = information.entity_name
      ? information.entity_name.trim()
      : "";
    const entityType = information?.entity_type_name
      ? information.entity_type_name.trim()
      : "";
    const EndpointType = information?.endpoint_type_name
      ? information.endpoint_type_name.trim()
      : "";
    const entityadd = information.recipient_endpoint_address
      ? information.recipient_endpoint_address.trim()
      : "";
    const entityUser = information.recipient_endpoint_username
      ? information.recipient_endpoint_username.trim()
      : "";
    const entitypass = information.recipient_endpoint_password
      ? information.recipient_endpoint_password.trim()
      : "";

    if (!entityname ||!entityadd ||!entityUser ||!entitypass ||!entityType ||!EndpointType
    ) {
      setError("Please enter all the fields mandatory.");
      setTimeout(() => {
        handleCloseErrorcode();
      }, 5000);
    } else {
      setBackDrop(true);
      const body = {
        entity_id: information?.entity_id,
        entity_name: information?.entity_name,
        entity_sender_code: information?.entity_sender_code,
        entity_receiver_code: information?.entity_receiver_code,
        entity_org_code: information?.entity_org_code,
        entity_type_id: information?.entity_type_id,
        recipient_endpoint_address: information?.recipient_endpoint_address,
        recipient_endpoint_username: information?.recipient_endpoint_username,
        recipient_endpoint_password: information?.recipient_endpoint_password,
        recipient_endpoint_folder: information?.recipient_endpoint_folder,
        recipient_endpoint_port: information?.recipient_endpoint_port,
        recipient_endpoint_type_id: information?.recipient_endpoint_type_id,
      };
      instance
        .post("api/v1/Master/Entity/Post", body)
        .then((res) => {
          if (res?.data?.Success) {
            setError("");
            setSuccess(res?.data?.ResultMessage);
            GetMaintainData(1);
            setTimeout(() => {
              setSuccess(null);
            }, 5000);
          } else {
            setError(res?.data?.ResultMessage);
            setTimeout(() => {
              setError(null);
            }, 5000);
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          setBackDrop(false);
        });
    }
  };
  useEffect(() => {
    GetEntityTypeData();
    GetEndpointData();
  }, []);

  useEffect(() => {
    GetMaintainData(pageNo, sortField, sortOrder);
  }, [sortField, sortOrder]);

  return (
      <div className="parent_div">
        <div
          style={{ display: "flex", justifyContent: "space-between" }}
          className="mb-4"
        >
          <p className="heading_font">Entity Management</p>
          <p className="head_div"></p>
        </div>
        <Grid container justifyContent="space-between" spacing={2}>
          <Grid item xl={1.5} lg={2} md={6} sm={12} xs={12}>
            <Button
              variant="contained"
              className="button_header"
              onClick={handleButtonClick}
              color="secondary"
              sx={{
                width: "100%",
                textTransform: "none",
              }}
            >
              Add Entity <AddIcon />
            </Button>
          </Grid>
          <Grid item xl={3} lg={3} md={6} sm={12} xs={12}>
            <div className="search-section d-flex">
              <div>
                <img src="assets/Images/searchicon.svg" alt="Search Icon" />
              </div>
              <div className="search-input">
                <input
                  onKeyUp={(event) => {
                    if (event.key === "Enter") {
                      GetMaintainData(
                        1,
                        sortField,
                        sortOrder,
                        event.target.value
                      );
                    }
                  }}
                  onChange={(event) => {
                    setSearchText(event.target.value);
                    if (event.target.value.length === 0) {
                      GetMaintainData(1, sortField, sortOrder, "");
                    }
                  }}
                  type="text"
                  placeholder="Search / Filter"
                />
              </div>
            </div>
          </Grid>
        </Grid>
        
        <EntityDrawer
          setBackDrop={setBackDrop}
          backDrop={backDrop}
          isDrawerOpen={isDrawerOpen}
          setIsDrawerOpen={setIsDrawerOpen}
          drawerWidth={drawerWidth}
          handleDrawerClose={handleDrawerClose}
          handleInputChange={handleInputChange}
          addentity={addentity}
          setAddentity={setAddentity}
          entitytypedata={entitytypedata}
          endpointtypedata={endpointtypedata}
          handle_createEntity={handle_createEntity}
          error={error}
          success={success}
          handleCloseErrorcode={handleCloseErrorcode}/>

        <EditEntityDrawer
          setBackDrop={setBackDrop}
          backDrop={backDrop}
          isDrawerOpen={isDrawerOpenedit}
          drawerWidth={drawerWidth}
          handleDrawerCloseedit={handleDrawerCloseedit}
          handleInputChange={handleInputChange}
          maindata={maindata}
          setMaindata={setMaindata}
          entitytypedata={entitytypedata}
          endpointtypedata={endpointtypedata}
          handle_EditEntity={handle_EditEntity}
          error={error}
          success={success}
          handleCloseErrorcode={handleCloseErrorcode}/>

         <EntityTable 
         loader={loader}
         anchorEl={anchorEl}
         sortField={sortField}
         sortOrder={sortOrder}
         handleSort={handleSort}
         getmaintaindata={getmaintaindata}
         handleEditClick={handleEditClick}
         selectedRowIndex={selectedRowIndex}
         handleClickEditDelete={handleClickEditDelete}
         />
        <Grid item xs={12} className="mt-4" sx={{ textAlign: "center" }}>
          {totalRecods > getmaintaindata.length &&
            getmaintaindata.length > 0 && (
              <Button
                id="back-button"
                variant="contained"
                color="secondary"
                sx={{ textTransform: "none" }}
                onClick={() => {
                  setShowmoreLoader(true);
                  setPageNo((prev) => prev + 1);
                  GetMaintainData(pageNo + 1, sortField, sortOrder);
                }}
              >
                {showmoreLoader ? "loading" : "Show More"}
              </Button>
            )}
        </Grid>
      </div>
  );
};
export default MaintainEntity;
